import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/storage'
firebase.initializeApp({
    apiKey: "AIzaSyCXGYGQr9183c4Q58vocjkAdKXKVo0uq80",
    authDomain: "kyungridan-today.firebaseapp.com",
    // databaseURL: "https://kyungridan-today.firebaseio.com",
    projectId: "kyungridan-today",
    storageBucket: "kyungridan-today.appspot.com",
    // messagingSenderId: "945927539270"
})

const db = firebase.firestore()
db.settings({ timestampsInSnapshots: true })

const storage = firebase.storage().ref()

export { firebase, db, storage }